import { useRecoilValue, useSetRecoilState } from "recoil";
import { alertListState, removeAlertStateSelector } from "../store/AlertState";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  message: {
    whiteSpace: 'pre-line'
  }
});

export const AlertDisplay = () => {
  const alertList = useRecoilValue(alertListState);
  const removeAlert = useSetRecoilState(removeAlertStateSelector);

  const classes = useStyles();

  if (alertList.length === 0) {
    return null;
  }

  const handleClose = alertInfo => {
    removeAlert(alertInfo);
  };

  const verticalOffset = {
    top: {
      left: null,
      center: null,
      right: null
    },
    bottom: {
      left: null,
      center: null,
      right: null
    }
  };

  return (
    <>
      {alertList.map((alertInfo, idx) => {
        const pos = alertInfo.option.position;
        const offsetValue = verticalOffset[pos[0]][pos[1]] || alertInfo.option.verticalOffset;
        const style = {
          [pos[0]]: offsetValue
        };

        if (pos[1] !== 'center') {
          style[pos[1]] = alertInfo.option.horizontalOffset;
        }

        let offset = 56;
        const count = (alertInfo.text.match(/\n/g) || []).length;
        if (count) {
          offset += count * 20;
        }
        verticalOffset[pos[0]][pos[1]] = offsetValue + offset;

        return (
          <Snackbar open={true} key={alertInfo.id} anchorOrigin={{vertical: pos[0], horizontal: pos[1]}} style={style}>
            {alertInfo.option.close ?
              <Alert severity={alertInfo.type} onClose={()=>{handleClose(alertInfo)}} classes={{message: classes.message}}>{alertInfo.text}</Alert>
              : <Alert severity={alertInfo.type} classes={{message: classes.message}}>{alertInfo.text}</Alert>
            }
          </Snackbar>
        );
      })}
    </>
  );
};

